export const SET_SOCIAL = 'setSocial'
export const SET_SOCIALS = 'setSocials'
export const SET_BS_SOCIALS = 'setBSSocials'
export const SOCIAL_RESET = 'socialReset'
export const SET_SOCIAL_HINT = 'setSocialHint'
export const SET_SOCIAL_EDIT = 'setSocialEdit'